import Plotly from 'plotly.js/lib/core'
Plotly.register([
  require('plotly.js/lib/bar')
])

import {
  Button
} from 'element-ui'
import Icon from 'vue-awesome/components/Icon.vue'
import 'vue-awesome/icons/download'
import { getChartDataFromResult, getChartXaxisRange, getChartYaxisRange } from '@/services/data'

export default {
  name: 'result-chart',
  props: ['layout', 'query', 'results', 'glossary'],
  components: {
    elButton: Button,
    Icon
  },
  data() {
    const d = new Date()
    return {
      imageUrl: '#',
      today: d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate()
    }
  },
  computed: {
    chartData() {
      if (this.results && this.results.length >= 1) {
        return getChartDataFromResult(this.results[0].data)
      } else {
        return { x: [], y: [] }
      }
    },
    data: function () {
      const { x, y } = this.chartData

      return [{
        type: 'bar',
        name: this.$t('pages.chart.title'),
        x: x,
        y: y,
        marker: {
          color: '#35C1D6'
        }
      }]
    },
    jsonFilters: function () {
      if (this.query.filters) {
        return JSON.parse(this.query.filters)
      }
      return []
    },
    title: function () {
      const { type, collection, value, filters } = this.query
      let title = 'Base Artl@s : '
      if (filters) title += '(' + this.$t('pages.chart.advancedSearch') + ') '
      switch (type) {
        case 'exhibition':
          let collectionType = ''
          if (collection !== 'all' && this.glossary) {
            this.glossary.exhibitionGroups.map(c => {
              if (c.id === parseInt(collection, 10)) {
                if (window.localStorage.language == 'fr_FR') {
                  collectionType = c.typefr
                }
                else {
                  collectionType = c.typeen
                }
              }
            })
          }
          if (value && value.length > 0) {
            title += this.$t('pages.chart.exhibitionTitles') +
              (collectionType !== '' ? this.$t('pages.chart.ofType') + collectionType : '') +
              this.$t('pages.chart.includes', { value })
          } else {
            title += this.$t('pages.chart.allExhibition') +
              (collectionType !== '' ? ` de type '${collectionType}' ` : '')
          }
          break
        case 'exhibited_work':
          if (value && value.length > 0) {
            title += this.$t('pages.chart.exhibitedWorkWith', { value })
          } if (this.jsonFilters.length > 0) {
            const firstFilter = this.jsonFilters[0]
            title += this.$t('pages.chart.allExhibitedWorks') + ' '
            title += this.$t('pages.chart.includes', { value: firstFilter[2] })
            title += ' (' + this.$t('pages.results.' + firstFilter[0].toLowerCase()) + ')'
          } else {
            title += this.$t('pages.chart.allExhibitedWorks')
          }
          break
        case 'exhibitor':
          if (value && value.length > 0) {
            title += this.$t('pages.chart.exhibitorsNameWith', { value })
          } else {
            title += this.$t('pages.chart.allExhibitors')
          }
          break
      }
      return title
    },
    count: function () {
      let count = ''
      if (this.results && this.results.length) {
	      count += this.results[0].data.length
      }
      switch (this.query.type) {
        case 'exhibition':
          count += this.$t('pages.chart.exhibitions')
          break
        case 'exhibitor':
          count += this.$t('pages.chart.exhibitors')
          break
        case 'exhibited_work':
          count += this.$t('pages.chart.exhibitedWorks')
          break
      }
      return count
    },
    defaultLayout: function () {
      const { x, y } = this.chartData
      const xaxisRange = getChartXaxisRange(x)
      const yaxisRange = getChartYaxisRange(y)

      let xaxis = {
        fixedrange: true,
        range: xaxisRange,
        type: 'linear'
      }
      let yaxis = {
        fixedrange: true,
        range: yaxisRange,
        color: '#48616a',
        type: 'linear',
        tickmode: 'auto',
        nticks: 8,
        dtick: 1
      }

      let text = []

      this.jsonFilters.map(filter => {
        if (filter[2] !== '') {
          text.push(`${this.$t('pages.results.' + filter[0].toLowerCase())}: ${filter[2]}`)
        }
      })
      let filtersAnnotations = [{
        showarrow: false,
        text: text.join(', '),
        yref: 'paper',
        xref: 'paper',
        y: 1.2,
        x: 0,
        yanchor: 'top',
        xanchor: 'left'
      }]

      let today = new Date()
      return {
        title: this.title,
        font: {
          family: 'Arial',
          size: 13,
          color: '#48616a'
        },
        titlefont: {
          size: 14,
          color: '#1f363d'
        },
        height: 500,
        margin: {
          l: 50,
          r: 50,
          b: 40,
          t: 60,
          pad: 4
        },
        xaxis: xaxis,
        yaxis: yaxis,
        showlegend: true,
        legend: {
          yanchor: 'bottom',
          y: -0.3,
          xanchor: 'center',
          x: 0.5,
          orientation: 'h'
        },
        annotations: [...filtersAnnotations, {
          showarrow: false,
          text: this.$t('pages.results.credits') + ', ' + today.toLocaleDateString(),
          yref: 'paper',
          xref: 'paper',
          width: 0.5,
          y: -0.38,
          x: 1,
          yanchor: 'bottom',
          xanchor: 'right'
        }, {
          showarrow: false,
          text: 'Total : ' + this.count,
          yref: 'paper',
          xref: 'paper',
          y: 1.1,
          x: 0,
          yanchor: 'top',
          xanchor: 'left'
        }]
      }
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    exportChart() {
      document.getElementById('imageLink').click()
    },
    fillData() {
      setTimeout(() => {
        const fullWidth = this.layout.indexOf('column-100') !== -1
        const fullHeight = this.layout.indexOf('full-height') !== -1

        Plotly.purge('chart-export')
        Plotly.newPlot(
          'chart-export',
          this.data, {
            ...this.defaultLayout,
            margin: {
              l: 50,
              r: 50,
              b: 120,
              t: 120,
              pad: 4
            },
            legend: {
              orientation: 'h',
              x: -0.025,
              y: -0.1,
              xanchor: 'left'
            }
          })
          .then((gd) => {
            Plotly.toImage(gd, { height: 500, width: 900 })
              .then((url) => {
                this.imageUrl = url
              }
              )
          })

        var layout = Object.assign({}, this.defaultLayout)
        layout.title = this.title
        layout.font = {
          family: 'Montserrat',
          size: 13,
          color: '#48616a'
        }
        layout.title = this.title
        layout.height = fullHeight ? 500 : 300
        layout.margin.t = fullWidth ? 90 : 80
        layout.paper_bgcolor = 'transparent'
        layout.plot_bgcolor = 'transparent'
        // layout.annotations = [{
        //   showarrow: false,
        //   text: 'Total : ' + this.count,
        //   yref: 'paper',
        //   xref: 'paper',
        //   y: fullHeight ? 1.1 : 1.2,
        //   x: fullHeight ? 0.5 : 0,
        //   yanchor: 'top',
        //   xanchor: fullHeight ? 'auto' : 'left'
        // }]
        Plotly.purge('chart')
        Plotly.newPlot('chart', this.data, layout, { displayModeBar: false, hoverinfo: 'x' })
      }, 300)
    }
  },
  watch: {
    'results': 'fillData',
    'layout': 'fillData'
  }
}



// WEBPACK FOOTER //
// ./src/components/Result/ResultChart/ResultChart.js